<template>
  <div>
    <footer class="main-footer no-print text-center">
      <!-- To the right -->
      <div class="float-right d-none d-sm-inline">

      </div>
      <!-- Default to the left -->
      <strong>Copyright &copy;
        {{year}}
        <a href="#">Small Business Corporation</a>.</strong> All rights reserved.
    </footer>
  </div>

</template>
<script>
  export default {
    data(){
      return{
        year:null,
      }
    },
    mounted() {
      this.year = new Date().getFullYear();
    },
  }
</script>